import {
  Box,
  Button,
  IconButton,
  SelectChangeEvent,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { SetStateAction, useEffect, useState } from "react";
import PolicyListingCard from "../PolicyListingCard/PolicyListingCard";
import { PolicyListingResponsiveStyles } from "./PolicyListingResponsiveStyles";
import { FILTER, NO_DATA_AVAILABLE, TAB1 } from "../../constants";
import DropDown from "../../common/DropDown/DropDown";
import ImageAndText from "../ImageAndText/ImageAndText";
import filterIcon from "../../assets/svgs/filter-icon.svg";
import { filterPopUpCommonOptions } from "../../constants/FilterPopUpCommonOptions";
import FilterPopUp from "../FilterPopUp/FilterPopUp";
import {
  CustomerListingProps,
  PolicyListingDataProps,
} from "../PolicyListingList/PolicyListingList";
import { IAgentPoliciesListing } from "../../models/agent/policiesListing";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Dispatch } from "@reduxjs/toolkit";
import { useAppSelector } from "../../store/hooks";
import { RootState } from "../../store/store";
import { currencyFormat } from "../../utils/Utility";

interface PolicyListingResponsiveDataProps {
  activeTab: string;
  policyListingData: IAgentPoliciesListing[];
  policiesThatNeedAttention: IAgentPoliciesListing[];
  customerPoliciesData?: CustomerListingProps[];
  customerPoliciesThatNeedAttention?: CustomerListingProps[];
  setContinuationId?: Dispatch<SetStateAction<any>>;
  setPrevId?: Dispatch<SetStateAction<any>>;
  showFilters: boolean;
}
const PolicyListingResponsive: React.FC<PolicyListingResponsiveDataProps> = ({
  policyListingData,
  customerPoliciesData,
  policiesThatNeedAttention,
  activeTab,
  customerPoliciesThatNeedAttention,
  setContinuationId,
  setPrevId,
  showFilters,
}) => {
  const isSmallScreen = useMediaQuery("(max-width:1023px)");

  const [tabsData, setTabsData] = useState<
    IAgentPoliciesListing[] | CustomerListingProps[]
  >(policyListingData);
  const [value, setValue] = useState("1");

  const handleDropDownChange = (event: SelectChangeEvent) => {
    setValue(event.target.value);
  };
  useEffect(() => {
    if (activeTab === TAB1) {
      if (value == "2") {
        setTabsData(policiesThatNeedAttention);
      } else {
        setTabsData(policyListingData);
      }
    } else {
      if (value == "1") {
        customerPoliciesThatNeedAttention &&
          setTabsData(customerPoliciesThatNeedAttention);
      } else {
        customerPoliciesData && setTabsData(customerPoliciesData);
      }
    }
  }, [activeTab, value, policyListingData]);
  const [selectedKey, setSelectedKey] = useState(
    filterPopUpCommonOptions[0].key
  );
  const { nextContinuationId, prevContinuationId, currentContinuationId } =
    useAppSelector((state: RootState) => state.agentPolicies);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (key: string) => {
    setSelectedKey(key);
    handleClose();
  };

  const goToPrevPage = () => {
    if (prevContinuationId !== undefined && setPrevId && setContinuationId) {
      setContinuationId(null);
      setPrevId(prevContinuationId);
    }
  };
  const goToNextPage = () => {
    if (nextContinuationId !== undefined && setContinuationId && setPrevId) {
      setPrevId(null);
      setContinuationId(nextContinuationId);
    }
  };
  return (
    <>
      <Box sx={PolicyListingResponsiveStyles.policyListingContainer}>
        <Box sx={PolicyListingResponsiveStyles.header}>
          <Box sx={PolicyListingResponsiveStyles.dropDownContainer}>
            {/* <DropDown
              data={[
                { name: "All Policies", value: 1 },
                { name: "Policies That Need Attention", value: 2 },
              ]}
              placeholder={"Policies That Need Attention"}
              selectedValue={value}
              onChange={handleDropDownChange}
            /> */}
            {isSmallScreen && showFilters && (
              <ImageAndText
                onhandleClick={handleClick}
                image={filterIcon}
                text={FILTER}
              />
            )}
          </Box>
        </Box>
        <Box sx={PolicyListingResponsiveStyles.container}>
          {tabsData === null || !tabsData?.length ? (
            <Typography>{NO_DATA_AVAILABLE}</Typography>
          ) : (
            tabsData
              ?.filter((row) => {
                if (!showFilters) return true;
                const selectedFilterValue = filterPopUpCommonOptions.find(
                  (option) => option.key === selectedKey
                )?.value;
                return (
                  selectedKey === "all" ||
                  !selectedKey ||
                  row.cancelRequestedByCd === selectedFilterValue
                );
              })
              ?.map((policy, index) => {
                const {
                  customerId,
                  inforcePremium,
                  totalFeeAmount,
                  insuredName,
                  carrierPolicyStatus,
                  carrierPolicyNo,
                  tenure,
                  lobCode,
                  carrierGroupCd,
                  cancelRequestedByCd,
                } = policy;

                // if (typeof customerDetails === "string" || !policyDetails) {
                //   return null;
                // }

                return (
                  <PolicyListingCard
                    key={index}
                    image={""}
                    customerName={insuredName || ""}
                    customerNumber={customerId || ""}
                    policyNumber={carrierPolicyNo || ""}
                    policyTypeNumber={lobCode || ""}
                    customerStatus={carrierPolicyStatus || ""}
                    customerPremium={currencyFormat(
                      "us",
                      inforcePremium + totalFeeAmount
                    )}
                    customerTerm={tenure}
                    // customItems={lobCode}
                    customerCarrier={carrierGroupCd || ""}
                    cancelRequestedByCd={cancelRequestedByCd || ""}
                  />
                );
              })
          )}
        </Box>

        {/* <IconButton
              onClick={() => navigate("/admin/lookup")}
              aria-label="recipe"
            >
              <ArrowBackOutlined />
            </IconButton> */}

        {tabsData !== null && tabsData?.length !== 0 && (
          <Box sx={{ display: "flex", alignSelf: "flex-end", gap: 2 }}>
            <Tooltip title="Prev">
              <span>
                <IconButton
                  onClick={goToPrevPage}
                  disabled={
                    (prevContinuationId === null &&
                      currentContinuationId === null) ||
                    (prevContinuationId === "" && currentContinuationId !== "")
                  }
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    padding: 0,
                    minWidth: "unset",
                  }}
                >
                  <ChevronLeftIcon sx={{ fontSize: 24 }} />
                </IconButton>
              </span>
            </Tooltip>

            <Tooltip title="Next">
              <span>
                <IconButton
                  onClick={goToNextPage}
                  disabled={
                    nextContinuationId === null || nextContinuationId === ""
                  }
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    padding: 0,
                    minWidth: "unset",
                  }}
                >
                  <ChevronRightIcon sx={{ fontSize: 24 }} />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        )}
      </Box>

      <FilterPopUp
        options={filterPopUpCommonOptions}
        selectedKey={selectedKey}
        onSelect={handleSelect}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      />
    </>
  );
};

export default PolicyListingResponsive;
